import { render, staticRenderFns } from "./OrganisationTable.vue?vue&type=template&id=ed62da10"
import script from "./OrganisationTable.vue?vue&type=script&lang=js"
export * from "./OrganisationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports